import { IMAGES } from "./site";

export const COMPANIES = [
    {
        slug: "digon",
        route: "/companies/digon",
        cardTitle: "DIGON POWER",
        fullName: "PT DIGON POWER TRANSMISSION",
        category: "TRANSMISI LISTRIK",
        tagline: "Keunggulan di Setiap Jalur",
        heroTitle: "KEUNGGULAN DI SETIAP JALUR",
        heroSubtitle: "Spesialis Transmisi Listrik",
        image: IMAGES.digon,
        logo: "/assets/logo-digon-transparent.png",
        cardImage: "https://images.unsplash.com/photo-1564415061701-26c564ecdc66?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHwzfHxwb3dlciUyMHRyYW5zbWlzc2lvbiUyMHRvd2VycyUyMGJyaWdodCUyMHNreXxlbnwwfHx8fDE3OTE0NzY2MjZ8MA&ixlib=rb-4.1.0&q=85&w=1200&h=800&fit=crop",
        pdf: "/downloads/PT. Digon Power Transmission - Company Profile.pdf",
        pdfLabel: "PT. Digon Power Transmission - Company Profile.pdf",
        description:
            "Perusahaan yang berfokus pada transmisi, menghadirkan infrastruktur transmisi listrik yang andal melalui eksekusi terbukti, tenaga kerja tangguh, dan keunggulan di lingkungan yang menantang.",
        cardCapabilities: [
            "Jalur Transmisi Tegangan Tinggi",
            "Pengembangan Gardu Induk",
            "Pekerjaan Sipil",
            "Ereksi Menara",
            "Penarikan & Pemasangan (Stringing)",
            "Komisioning & Rekayasa",
            "Operasi & Pemeliharaan",
            "Dukungan Proyek & Logistik",
        ],
        highlight: { value: "20+", label: "Tahun Pengalaman" },
        about: [
            "Kami adalah perusahaan yang berfokus pada transmisi dengan pengalaman terbukti lebih dari 20 tahun, dibangun di atas tenaga kerja yang kuat dan tangguh.",
            "Kekuatan inti kami terletak pada eksekusi proyek di medan yang menantang dan kompleks, di mana presisi, kecepatan, dan keandalan sangat penting. Kami tidak sekadar membangun infrastruktur — kami memastikan penyampaian dengan kepastian.",
        ],
        vision: "Menjadi kekuatan terdepan dalam infrastruktur transmisi listrik Indonesia, diakui atas keunggulan rekayasa, kekuatan eksekusi, dan keandalan tanpa kompromi.",
        mission: [
            "Menghadirkan solusi transmisi kelas dunia dengan presisi, konsistensi, dan akuntabilitas.",
            "Memanfaatkan tenaga kerja yang tangguh dan berpengalaman sebagai fondasi keunggulan operasional.",
            "Mengeksekusi proyek kompleks dan berisiko tinggi di medan yang menantang dengan kapabilitas unggul.",
            "Menjunjung standar keselamatan, mutu, dan kepatuhan tertinggi dalam setiap operasi.",
            "Membangun kemitraan strategis jangka panjang dengan PLN, kontraktor EPC, dan pemangku kepentingan global.",
            "Mendorong inovasi berkelanjutan untuk meningkatkan kinerja, efisiensi, dan penyampaian proyek.",
        ],
        strengths: [
            {
                title: "Tenaga Kerja Tangguh & Berpengalaman",
                desc: "Tim terlatih dengan adaptabilitas lapangan yang kuat.",
            },
            {
                title: "Keahlian di Medan Menantang",
                desc: "Kapabilitas terbukti di pegunungan, hutan, dan daerah terpencil.",
            },
            {
                title: "Keunggulan Eksekusi",
                desc: "Perencanaan kuat, mobilisasi cepat, dan penyampaian presisi.",
            },
            {
                title: "Komitmen pada Keselamatan & Mutu",
                desc: "Mentalitas zero accident dengan standar kepatuhan ketat.",
            },
        ],
        services: [
            "Pekerjaan Sipil (pondasi, jalan akses, dll.)",
            "Ereksi Menara",
            "Penarikan & Pemasangan (Stringing)",
            "Dukungan Proyek dan Logistik",
            "Gardu Induk & Elektromekanikal",
            "Operasi & Pemeliharaan",
            "Komisioning & Rekayasa",
        ],
        projectIntro:
            "Selama lebih dari 20 tahun, kami telah menyelesaikan lebih dari 100.000 proyek jalur transmisi dan gardu induk, termasuk SUTT, SUTET, dan gardu induk — di seluruh pulau di Indonesia dan Timor-Leste.",
        projects: [
            {
                name: "SUTET 500V Program",
                client: "PT Tehate",
                scope: "Kupang · NTT · Sampit · Pangkalan Bun · Gardu Induk Sampit · Gardu Induk Maumere · Cilacap",
            },
            {
                name: "SUTET Teluk Naga 500 KV",
                client: "PT Percie",
                scope: "Jalur transmisi tegangan ekstra tinggi",
            },
            {
                name: "SUTT Pati – Rembang 150 KV",
                client: "PT Citacontractor",
                scope: "Jalur transmisi tegangan tinggi",
            },
        ],
        clientsNote:
            "Dipercaya oleh klien dan mitra terkemuka di sektor transmisi Indonesia.",
        experienceHighlights: [
            "Pengalaman 20+ tahun",
            "Proyek jalur transmisi dan gardu induk",
            "SUTT PLN telah dibangun",
            "SUTET (Jaringan Listrik)",
            "Gardu Induk",
            "Medan menantang",
            "Indonesia",
            "Timor-Leste",
        ],
        platforms: [
            { num: "01", name: "JALUR TRANSMISI TEGANGAN TINGGI" },
            { num: "02", name: "PENGEMBANGAN GARDU INDUK" },
            { num: "03", name: "PROYEK PERLUASAN GRID" },
            { num: "04", name: "PENGUJIAN & KOMISIONING" },
            { num: "05", name: "INFRASTRUKTUR KELISTRIKAN DATA CENTER" },
        ],
        contact: {
            email: "masriadli@digonpowertransmission.com",
            phones: ["+628-1758-1774"],
            address: "Komplek PP No. B6 Banyumanik-Semarang",
        },
    },
    {
        slug: "sadja-group",
        route: "/companies/sadja-group",
        cardTitle: "SADJA GROUP",
        fullName: "PT SADJA GROUP INDONESIA",
        category: "KONSTRUKSI & PENGEMBANGAN PROPERTI",
        tagline: "Konstruksi • Arsitektur • Infrastruktur",
        heroTitle: "SADJA GROUP INDONESIA",
        heroSubtitle: "Konstruksi • Arsitektur • Infrastruktur",
        image: IMAGES.sadjaGroup,
        logo: "/assets/logo-sadja-group-transparent.png",
        cardImage: "https://images.unsplash.com/photo-1527335988388-b40ee248d80c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHwyfHxicmlnaHQlMjBjb25zdHJ1Y3Rpb24lMjBzaXRlJTIwZGF5dGltZSUyMG1pbmltYWx8ZW58MHx8fHwxNzkxNDc2NjQxfDA&ixlib=rb-4.1.0&q=85&w=1200&h=800&fit=crop",
        pdf: "/downloads/PT. Sadja Group Indonesia Company Profile.pdf",
        pdfLabel: "PT. Sadja Group Indonesia Company Profile.pdf",
        description:
            "Perusahaan pengembangan Konstruksi, Desain Arsitektur & Transmisi Listrik yang multidisiplin, menghadirkan proyek sipil, komersial, residensial, arsitektural, dan terkait transmisi bagi klien di seluruh Indonesia.",
        cardCapabilities: [
            "Konstruksi Sipil",
            "Desain Arsitektur",
            "Konstruksi Bangunan",
            "Pekerjaan Pondasi & Struktur",
            "Pengurukan & Pemadatan Tanah",
            "Konstruksi Transmisi",
            "Pengembangan Properti",
        ],
        about: [
            "PT Sadja Group Indonesia memiliki kompetensi di bidang usaha jasa konstruksi, desain arsitektur, dan transmisi listrik — didukung oleh tim manajemen dan sumber daya berpengalaman sesuai keahliannya, dengan dedikasi yang luar biasa pada bidangnya.",
            "Kami percaya setiap bentuk tanggung jawab yang diberikan kepada kami akan diselesaikan bagi klien. Kami terus mengembangkan inovasi, meningkatkan kualitas, serta berkolaborasi dengan menerapkan sistem kerja yang efisien dalam setiap layanan yang kami berikan. Poin penting kami adalah tetap menjaga kepercayaan dan kepuasan klien melalui hasil kinerja PT Sadja Group Indonesia.",
        ],
        specializations: [
            {
                title: "Pekerjaan Sipil Konstruksi & Desain",
                desc: "Pembangunan pondasi, menara, fabrikasi, pemasangan struktur, pembangunan gedung, serta seluruh pekerjaan sipil dan desain arsitektural.",
            },
            {
                title: "Pengurukan dan Pemadatan Tanah",
                desc: "Persiapan dan perbaikan lahan untuk kebutuhan proyek infrastruktur, termasuk pembersihan, pemotongan, pengurukan tanah, dan pemadatan area kerja.",
            },
            {
                title: "Pekerjaan SUTT PLN (SUTET Stringing & Erection)",
                desc: "Pelaksanaan penarikan dan penyambungan konduktor bertegangan tinggi, dilakukan dengan standar keselamatan dan akurasi tinggi di berbagai kondisi medan.",
            },
            {
                title: "Konstruksi Bangunan",
                desc: "Penyampaian bangunan komersial dan residensial, dari struktur hingga penyelesaian.",
            },
            {
                title: "Desain Arsitektur",
                desc: "Layanan desain arsitektur terintegrasi yang mendukung konstruksi dan pengembangan properti.",
            },
            {
                title: "Pengembangan Properti",
                desc: "Pengembangan properti menyeluruh dari konsep dan perencanaan hingga serah terima.",
            },
        ],
        trackRecord: [
            "SUTT PLN — 20 tahun berpengalaman sebagai sub-kontraktor oleh Digon Power",
            "2024–2025 · Pembangunan Break Water Pantai Asem Doyong KSO PT. Wahyu Jati Abadi (Pemalang)",
            "2024–2025 · Pembangunan gedung sekolah SMA & SMK (Pemprov Jawa Tengah)",
            "2024–2025 · Revitalisasi RUSUN & Fasum Perumahan (Dinas Perumahan & Pemukiman Kota Semarang)",
            "2024–2025 · China Road and Bridge Construction (CRBC) — Suplai PP Bamboo dan Boulder Rock",
            "2024–2026 · Kalla project house (Makassar), KSO Jovanindo Perdana",
            "2024–2025 · 4 Branch Best PR (Semarang)",
        ],
        workAreas: [
            {
                region: "Jawa",
                detail: "Priok 500KV, 2022 · Water Break Pemalang · Tol Semarang–Demak · Gedung Sekolah · Rumah Susun & Fasum Perumahan",
            },
            { region: "Kalimantan", detail: "Gunung Mas 150KV, 2025" },
            {
                region: "Timor Leste",
                detail: "Dili 150KV, 2011–2014 (PT. Tehate) — Subcon by Digon Power",
            },
            { region: "Bangka Belitung", detail: "150KV, 2025" },
            {
                region: "Sulawesi",
                detail: "Kendari 150KV, 2025 · Kalla Project House",
            },
        ],
        partners: [
            "PT Indisi",
            "PT Ayama",
            "PT Kembar Abadi",
            "PT Karya Mitra Nugraha (KMN)",
            "PT Wahyu Jati Abadi",
            "PT Enviromate Technology International (ETI)",
            "PT Banda Karya Abadi",
            "CV Jovanindo Perdana",
            "PT Best PR",
        ],
        management: [
            { name: "Bito Leilia Atmadja", role: "Direktur Utama" },
            { name: "Dra. Nany Lestari, MM", role: "Komisaris" },
            { name: "Bambang Slamet Riyadi (Digon)", role: "Komisaris" },
            { name: "Drs. Abasari, M.Hum", role: "Komisaris" },
            { name: "Bima Eka Sakti", role: "Direktur Operasional 1" },
            { name: "Aris Maulana Akbar, M.Si", role: "Direktur Operasional 2" },
        ],
        legality:
            "PT Sadja Group Indonesia beroperasi dengan legalitas perusahaan yang lengkap, Sertifikat Kompetensi Kerja (SKK), dan Sertifikat Badan Usaha (SBU) — terdokumentasi dalam profil perusahaan.",
        experienceHighlights: [
            "Konstruksi sipil",
            "Konstruksi sekolah",
            "Konstruksi breakwater",
            "Fasilitas perumahan / residensial",
            "Pasokan lahan dan dukungan infrastruktur",
            "Konstruksi terkait transmisi",
            "Proyek komersial",
        ],
        platforms: [
            { num: "01", name: "PEKERJAAN SIPIL BERKUALITAS TINGGI" },
            { num: "02", name: "SIPIL KOMERSIAL BERKUALITAS TINGGI" },
            { num: "03", name: "SIPIL RESIDENSIAL BERKUALITAS TINGGI" },
            { num: "04", name: "PENGEMBANGAN PROPERTI" },
        ],
        contact: {
            email: "official@sadjacorecorp.com",
            secondaryEmail: "business@bitoatmadja.com",
            phones: ["+62 817-581-174", "+62 818-181-174"],
            address: "Komplek PP No. B6 Banyumanik-Semarang",
        },
    },
    {
        slug: "orbito",
        route: "/companies/orbito",
        cardTitle: "ORBITO",
        fullName: "PT ORBITO INTEGRATED ENERGY",
        category: "ENERGI TERINTEGRASI",
        tagline: "Solusi Terintegrasi. Masa Depan Berkelanjutan.",
        heroTitle: "ORBITO INTEGRATED ENERGY",
        heroSubtitle: "Platform Energi Terintegrasi",
        image: IMAGES.orbito,
        logo: "/assets/logo-orbito-transparent.png",
        cardImage: "https://images.unsplash.com/photo-1508514177221-188b1cf16e9d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHw0fHxzb2xhciUyMHBhbmVscyUyMGJyaWdodCUyMHNreSUyMG1pbmltYWx8ZW58MHx8fHwxNzkxNDc2NjQxfDA&ixlib=rb-4.1.0&q=85&w=1200&h=800&fit=crop",
        pdf: "/downloads/PT ORBITO - INTEGRATED ENERGY.pdf",
        pdfLabel: "PT ORBITO - INTEGRATED ENERGY.pdf",
        description:
            "Platform pembangkitan listrik dan energi terintegrasi milik grup — menghadirkan solusi EPCC yang inovatif dan terintegrasi untuk kebutuhan energi Indonesia yang terus meningkat.",
        cardCapabilities: [
            "Pembangkit Listrik Tenaga Minyak Gas (PLTMG)",
            "Pembangkit Listrik Tenaga Surya (PLTS)",
            "Pengujian & Komisioning",
            "Operasi & Pemeliharaan",
            "Pembangkit Listrik Tenaga Gas (PLTMG)",
            "Dukungan Infrastruktur Minyak & Gas",
            "Sistem Penyimpanan Energi Baterai (BESS)",
            "Konstruksi Sipil, Mekanikal, dan Elektrikal",
            "Manajemen Pengadaan dan Rantai Pasok",
        ],
        about: [
            "PT. Orbito Integrated Energy (ORBITO) adalah entitas strategis di bawah naungan PT. Sadja Core Corp, perusahaan induk yang berdedikasi pada pengembangan bisnis energi dan infrastruktur. ORBITO berfokus pada penyediaan solusi Engineering, Procurement, Construction, and Commissioning (EPCC) yang inovatif dan terintegrasi, didukung tim manajemen dengan pengalaman puluhan tahun dalam proyek infrastruktur kelistrikan dan energi berskala besar di seluruh Indonesia.",
            "ORBITO merupakan sister company PT. Digon Power Transmission, perusahaan dengan pengalaman terbukti lebih dari 20 tahun dalam pembangunan Saluran Udara Tegangan Tinggi (SUTT) dan Saluran Udara Tegangan Ekstra Tinggi (SUTET) di medan-medan paling menantang di seluruh Indonesia. Sinergi ini memungkinkan ORBITO memadukan keahlian transmisi yang mendalam dengan visi yang luas di sektor pembangkitan listrik dan energi.",
            "Kami berkomitmen menjawab kebutuhan energi Indonesia yang terus meningkat dengan solusi yang berlandaskan mutu, efisiensi, inovasi, dan integritas. ORBITO lebih dari sekadar kontraktor — kami adalah mitra strategis yang berdedikasi membangun masa depan lanskap energi Indonesia.",
        ],
        vision: "Menjadi perusahaan energi terintegrasi terkemuka di Asia Tenggara — mengembangkan, membangun, mengoperasikan, dan memiliki aset energi strategis yang menggerakkan pertumbuhan berkelanjutan.",
        mission: [
            "Mendukung pelanggan industri dan utilitas.",
            "Menghadirkan layanan EPCC dan O&M kelas dunia.",
            "Mengembangkan proyek kelistrikan konvensional dan terbarukan.",
            "Membangun portofolio aset energi jangka panjang sebagai Independent Power Producer (IPP).",
        ],
        services: [
            "Pembangkit Listrik Tenaga Gas (PLTMG)",
            "Pembangkit Listrik Tenaga Surya (PLTS)",
            "Pengujian & Komisioning",
            "Operasi & Pemeliharaan",
            "Dukungan Infrastruktur Minyak & Gas",
            "Sistem Penyimpanan Energi Baterai (BESS)",
            "Konstruksi Sipil, Mekanikal, dan Elektrikal",
            "Manajemen Pengadaan dan Rantai Pasok",
        ],
        epcc: [
            {
                title: "Rekayasa (Engineering)",
                desc: "Profesional berkeahlian tinggi di berbagai disiplin, termasuk Sipil, Elektrikal, Mekanikal, dan Instrumentasi & Kontrol. Kami memanfaatkan perangkat lunak terkini dan mematuhi standar internasional (ASME, IEC, API) untuk menghasilkan desain yang andal, efisien, dan berkelanjutan.",
                items: [
                    "Studi Kelayakan & Desain Konseptual",
                    "Front-End Engineering Design (FEED)",
                    "Detailed Engineering Design (DED)",
                    "Value Engineering",
                ],
            },
            {
                title: "Pengadaan (Procurement)",
                desc: "Strategi pengadaan Orbito berfokus pada efisiensi, efektivitas biaya, dan keandalan.",
                items: [
                    "Global Sourcing & Manajemen Vendor",
                    "Quality Assurance & Control",
                    "Logistik & Expediting",
                ],
            },
            {
                title: "Konstruksi (Construction)",
                desc: "Tim konstruksi kami memiliki pengalaman luas dalam mengelola dan mengeksekusi proyek energi berskala besar.",
                items: [
                    "Persiapan Lokasi & Pekerjaan Sipil",
                    "Instalasi Mekanikal & Perpipaan",
                    "Instalasi Elektrikal & Instrumentasi",
                    "Manajemen & Supervisi Proyek",
                ],
            },
            {
                title: "Komisioning (Commissioning)",
                desc: "Spesialis komisioning Orbito memastikan seluruh sistem dan komponen diuji, diintegrasikan, dan dioptimalkan secara menyeluruh untuk kinerja puncak sebelum serah terima.",
                items: [
                    "Pra-Komisioning & Uji Fungsi",
                    "Pengujian Sistem Terintegrasi",
                    "Uji Kinerja & Optimasi",
                    "Pelatihan Operator & Serah Terima",
                ],
            },
        ],
        projectFocus: [
            {
                title: "Pembangkit Listrik Tenaga Mesin Gas (PLTMG)",
                desc: "Mengembangkan pembangkit listrik mesin gas yang efisien dan andal, mencakup seluruh aspek dari infrastruktur pasokan gas hingga evakuasi daya.",
            },
            {
                title: "Pembangkit Listrik Tenaga Surya (PLTS)",
                desc: "Mengimplementasikan pembangkit listrik tenaga surya fotovoltaik skala utilitas, termasuk solusi surya ground-mounted dan terapung.",
            },
        ],
        specialization: {
            title: "Menaklukkan Medan Sulit",
            desc: "Yang benar-benar membedakan PT. Orbito adalah keahlian tak tertandingi dalam mengeksekusi proyek di wilayah yang secara geografis menantang dan terpencil, khususnya di Indonesia Timur (Papua dan Nusa Tenggara Timur).",
            points: [
                "Geografi Ekstrem",
                "Kondisi Tanah Menantang",
                "Logistik Kompleks",
                "Manajemen Sumber Daya",
                "Kepedulian Lingkungan & Sosial",
            ],
        },
        whyPartner: [
            "Keahlian Terbukti",
            "Integrasi EPCC",
            "Penguasaan Medan Sulit",
            "Sumber Daya Manusia Elite",
            "Komitmen pada Keberlanjutan",
            "Didukung Sadja Core Corp",
        ],
        projects: [
            { name: "SUTET 500KV Tanjung Jati – Ungaran", client: "PT PLN (Persero)", year: "2004–2005" },
            { name: "SUTT 150KV Pacitan – Ponorogo", client: "PT Percie", year: "2007–2009" },
            { name: "SUTT 150KV Timor Leste", client: "PT Tehate", year: "2011–2013" },
            { name: "SUTET 500KV Batang – Mandirancan", client: "PT Kembar Abadi", year: "2017–2019" },
            { name: "SUTET 500KV Mandirancan", client: "PT Indisi", year: "2019" },
            { name: "SUTET 500KV Tanjung Jati – Ungaran", client: "PT Percie", year: "2017–2020" },
            { name: "SUTT 150KV Singkawang", client: "PT Ayama", year: "2013–2015" },
            { name: "SUTET 500KV Palu – Poso", client: "PT Percie", year: "2010–2012" },
            { name: "SUTET 500KV Sukabumi", client: "PT Tehate", year: "2011–2013" },
            { name: "Gardu Induk Semen Indonesia", client: "PT Tehate", year: "2017–2019" },
            { name: "SUTT 150KV Pulau Selaru", client: "PT Indokarya", year: "Beroperasi" },
            { name: "SUTET Banten – Suralaya", client: "PT BPS", year: "2012–2015" },
            { name: "SUTT Palu – Poso", client: "PT BPS", year: "Sistem Tegangan Tinggi" },
            { name: "SUTT Singkawang", client: "PT BPS", year: "Kalimantan Barat" },
            { name: "SUTET 500KV Tower 1–52 (23,6 KM)", client: "Samsung — Kontraktor: PT ETI", year: "2018–2020" },
            { name: "POWER XXI: Transmission Line 500 kV Purwodadi – Surabaya Barat", client: "PT PLN (Persero)", year: "1996" },
            { name: "Sub Marine Cable Java – Bali #2", client: "PT Pirelli Cable", year: "Ketapang – Banyuwangi, 2000" },
            { name: "Kabel Laut Tegangan Menengah 20KV Kalianget (P. Madura) – Talango (P. Poteran)", client: "PT PLN (Persero)", year: "2001–2002" },
            { name: "Proyek Stringing 500 KV Tanjung Jati B – Ungaran", client: "PT Multifab", year: "2004" },
            { name: "Rekonduktoring SUTT 150KV Pati–Rembang–Blora (PLTU 1 Jateng)", client: "PT PLN (Persero) P3B JB", year: "2006–2009" },
            { name: "150 KV and 500 KV T/L Works New Paiton East Java", client: "PT MSHE", year: "2009–2010" },
            { name: "Pembangunan T/L SUTT 150 kV Sengkang – Sidrap Section 2", client: "PT PLN (Persero)", year: "2010–2011" },
            { name: "Rekonduktoring SUTT 150 KV Kudus – Purwodadi", client: "PT PLN (Persero)", year: "2011–2015" },
            { name: "Supervisi T/L SUTT 150 KV Tenayan - Perawang", client: "PT PLN (Persero)", year: "2016–2019" },
        ],
        management: [
            { name: "Eddy Setya Budi", role: "Komisaris" },
            { name: "Bito Leilia Atmadja", role: "Direktur Utama" },
            { name: "Bima Eka Sakti", role: "Direktur Operasional 1" },
            { name: "Bambang Slamet Riyadi (Digon)", role: "Direktur Operasional 2" },
        ],
        experienceHighlights: [
            "Pembangkit Listrik Tenaga Mesin Gas (PLTMG)",
            "Pembangkit Listrik Tenaga Surya (PLTS)",
            "Pengujian & Komisioning",
            "Operasi & Pemeliharaan",
            "Sistem Penyimpanan Energi Baterai (BESS)",
        ],
        platforms: [
            {
                num: "01",
                name: "EKSEKUSI INTI",
                desc: "Pengembangan PLTMG, Solusi Gas-to-Power, Pembangkit Surya, Sistem Kelistrikan Hibrida, dan Solusi Captive Power.",
            },
            {
                num: "02",
                name: "DUKUNGAN SIKLUS HIDUP",
                desc: "Manajemen EPC, Pengembangan Aset (IPP), dan O&M Jangka Panjang.",
            },
        ],
        contact: {
            email: "business@bitoatmadja.com",
            phones: ["+62 817-581-174"],
            address:
                "Jl. Jenderal Sudirman No.Kav. 86, RT.10/RW.11, Karet Tengsin, Kecamatan Tanah Abang, Kota Jakarta Pusat, Daerah Khusus Ibukota Jakarta 10220, Indonesia",
        },
    },
    {
        slug: "kharisma-damar-satya",
        route: "/companies/kharisma-damar-satya",
        cardTitle: "KHARISMA DAMAR SATYA",
        fullName: "PT. KHARISMA DAMAR SATYA",
        category: "KONTRAKTOR UMUM & KONSTRUKSI",
        tagline: "We Build For All",
        heroTitle: "PT. KHARISMA DAMAR SATYA",
        heroSubtitle: "Kontraktor Umum & Konstruksi",
        image: "/assets/kds/cover.jpg",
        logo: "/assets/logo-damar-transparent.png",
        cardImage: "https://images.unsplash.com/photo-1479839672679-a46483c0e7c8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHw0fHxtb2Rlcm4lMjBicmlnaHQlMjBhcmNoaXRlY3R1cmUlMjBtaW5pbWFsfGVufDB8fHx8MTc5MTQ3NjYyNnww&ixlib=rb-4.1.0&q=85&w=1200&h=800&fit=crop",
        pdf: "/downloads/PT. Kharisma Damar Satya - Company Profile.pdf",
        pdfLabel: "PT. Kharisma Damar Satya - Company Profile.pdf",
        description:
            "PT. Kharisma Damar Satya adalah perusahaan konstruksi swasta berpengalaman di Indonesia dengan rekam jejak proyek residensial, perkantoran, komersial, industri, pergudangan, hospitality, infrastruktur, kesehatan, dan real estate.",
        cardCapabilities: [
            "Konstruksi Industri",
            "Infrastruktur",
            "Komersial",
            "Hospitality",
            "Residensial",
            "Perkantoran",
            "Pemeliharaan",
            "Kontraktor Umum",
        ],
        experienceHighlights: [
            "Industri — pabrik dan fasilitas produksi",
            "Infrastruktur — Terminal 3 Soekarno-Hatta",
            "Hospitality — proyek hotel",
            "Bangunan dan pengembangan komersial",
            "Konstruksi residensial",
            "Konstruksi kantor dan tempat kerja",
            "Kapabilitas pemeliharaan",
            "Berkantor pusat di Jakarta",
        ],
        platforms: [
            { num: "01", name: "KONSTRUKSI INDUSTRI" },
            { num: "02", name: "INFRASTRUKTUR" },
            { num: "03", name: "KOMERSIAL" },
            { num: "04", name: "HOSPITALITY" },
            { num: "05", name: "RESIDENSIAL" },
            { num: "06", name: "PERKANTORAN" },
            { num: "07", name: "PEMELIHARAAN" },
            { num: "08", name: "KONTRAKTOR UMUM" },
        ],
        contact: {
            email: "damarsatyacorp@gmail.com",
            phones: ["0817581774", "0818181774"],
            address: "Jl. Jenderal Sudirman No.86 Lantai Mezzanine, Karet Tengsin, Tanah Abang, Central Jakarta City, Jakarta 10220",
        },
    },
];

export const getCompany = (slug) => COMPANIES.find((c) => c.slug === slug);
